<template>
  <main class="page not-found-page">
    <div class="_container">
      <div class="not-found-page__wrapper">
        <img src="@/assets/img/svg/403.svg" alt="kendoo">
        <h4>Oops! Page is forbidden.</h4>
        <p>Probably, you should inform administrator for resolve this impediment.
          Meanwhile, you may return to main page.</p>
        <a href="https://kendoo.com" class="page-button">
          <div></div><div>BACK TO HOME</div><div></div>
        </a>
      </div>
    </div>
  </main>
</template>


<script>

export default {
    name: 'Error403',
    components: {},
}
</script>
